import { SubOption } from "model/Filters";

const languagesSubOptions = [
  {
    id: 91,
    name: 'English',
    value: 'english',
    short: 'en',
  },
  {
    id: 92,
    name: 'Nederlands',
    value: 'nederlands',
    short: 'nl',
  },
  {
    id: 93,
    name: 'Español',
    value: 'espa%C3%B1ol',
    short: 'es',
  },
  {
    id: 94,
    name: 'Deutsch',
    value: 'deutsch',
    short: 'de',
  },
  {
    id: 95,
    name: 'Français',
    value: 'fran%C3%A7ais',
    short: 'fr',
  },
  {
    id: 96,
    name: 'ελληνικά',
    value: '%CE%B5%CE%BB%CE%BB%CE%B7%CE%BD%CE%B9%CE%BA%CE%AC',
    short: 'el',
  },
  {
    id: 97,
    name: 'Italiano',
    value: 'italiano',
    short: 'it',
  },
  {
    id: 98,
    name: 'русский',
    value: '%D1%80%D1%83%D1%81%D1%81%D0%BA%D0%B8%D0%B9',
    short: 'ru',
  },
  {
    id: 99,
    name: 'עברית', // Hebrew
    value: '%D7%A2%D7%91%D7%A8%D7%99%D7%AA',
    short: 'he',
  },
  {
    id: 100,
    name: 'Hindi',
    value: 'hindi',
    short: 'hin',
  },
  {
    id: 101,
    name: 'Português',
    value: 'portugu%C3%AAs',
    short: 'pt',
  },
  {
    id: 102,
    name: 'Türkçe',
    value: 't%C3%BCrk%C3%A7e',
    short: 'tr',
  },
  {
    id: 103,
    name: 'Magyar', // Hungarian
    value: 'magyar',
    short: 'hu',
  },
  {
    id: 104,
    name: 'हिंदी',
    value: '%E0%A4%B9%E0%A4%BF%E0%A4%82%E0%A4%A6%E0%A5%80',
    short: 'hin',
  },
  {
    id: 105,
    name: 'ไทย',
    value: '%E0%B9%84%E0%B8%97%E0%B8%A2',
    short: 'th',
  },
  {
    id: 106,
    name: 'नेपाली',
    value: '%E0%A4%A8%E0%A5%87%E0%A4%AA%E0%A4%BE%E0%A4%B2%E0%A5%80',
    short: 'nep',
  },
  {
    id: 107,
    name: 'Sinhala',
    value: 'sinhala',
    short: 'sin',
  },
  {
    id: 108,
    name: 'தமிழ்',
    value: '%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D',
    short: 'tam',
  },
  {
    id: 109,
    name: 'العربية', // Arabic
    value: '%D8%A7%D9%84%D8%B9%D8%B1%D8%A8%D9%8A%D8%A9',
    short: 'ar',
  },
  {
    id: 111,
    name: 'Polski', // Polish
    value: 'polski',
    short: 'pl',
  },
  {
    id: 112,
    name: 'Eesti', // Estonian
    value: 'eesti',
    short: 'et',
  },
  {
    id: 113,
    name: 'Lietuvių', // Lithuanian
    value: 'lietuvi%C5%B3',
    short: 'lt',
  },
  {
    id: 114,
    name: 'Latviešu', // Latvian
    value: 'latvie%C5%A1u',
    short: 'lv',
  },
  {
    id: 115,
    name: 'Română', // Romanian
    value: 'rom%C3%A2n%C4%83',
    short: 'ro',
  },
  {
    id: 116,
    name: 'Hrvatski', // Croatian
    value: 'hrvatski',
    short: 'hr',
  },
  {
    id: 117,
    name: '中文', // Chinese
    value: '%E4%B8%AD%E6%96%87',
    short: 'zh',
  },
  {
    id: 118,
    name: 'slovenski', // Slovene
    value: 'slovenski',
    short: 'sl',
  },
  {
    id: 119,
    name: 'slovenský', // Slovak
    value: 'slovensk%C3%BD',
    short: 'sk',
  },
  {
    id: 120,
    name: 'Český', // Czech
    value: '%C4%8Desk%C3%BD',
    short: 'cs',
  },
  {
    id: 121,
    name: 'Suomi', // Finnish
    value: 'suomi',
    short: 'fi',
  },
  {
    id: 122,
    name: 'Svenska', // Swedish
    value: 'svenska',
    short: 'sv',
  },
  {
    id: 123,
    name: 'Norsk', // Norwegian
    value: 'norsk',
    short: 'no',
  },
  {
    id: 124,
    name: 'Dansk', // Danish
    value: 'dansk',
    short: 'da',
  },
  {
    id: 125,
    name: 'ייִדיש', // Yiddish
    value: '%D7%99%D7%99%D6%B4%D7%93%D7%99%D7%A9',
    short: 'yi',
  },
  {
    id: 126,
    name: '日本語', // Japanese
    value: '%E6%97%A5%E6%9C%AC%E8%AA%9E',
    short: 'ja',
  },
  {
    id: 127,
    name: 'Korean',
    value: 'korean',
    short: 'kor',
  },
  {
    id: 128,
    name: 'Tamil',
    value: 'tamil',
    short: 'tam',
  },
  {
    id: 129,
    name: 'Vietnamese',
    value: 'vietnamese',
    short: 'vie',
  },
] as SubOption[];


export default languagesSubOptions;
